import { render } from "./NotFound1.vue?vue&type=template&id=9d748754"
import script from "./NotFound1.vue?vue&type=script&lang=js"
export * from "./NotFound1.vue?vue&type=script&lang=js"

import "./NotFound1.vue?vue&type=style&index=0&id=9d748754&lang=scss"

import exportComponent from "../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__